const l = {
  name: "Giftcard2",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14.4,3.7C14.9,1.5,16.9,0,19.1,0c3.2,0,5.5,3,4.7,6.1l-0.1,0.2l0,0C23.6,6.9,23.4,7.5,23,8h12
			c2.8,0,5,2.2,5,5v16c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V13c0-2.8,2.2-5,5-5h0.1C4.7,7.5,4.5,6.9,4.3,6.3L4.2,6.1C3.5,3,5.8,0,9,0
			c2.2,0,4.2,1.5,4.7,3.7l0,0L14,5.1L14.4,3.7L14.4,3.7z M16.4,10l4.3,4.3l-1.4,1.4l-4.2-4.2V18H38v-5c0-1.7-1.3-3-3-3H16.4z
			 M11.6,10H5c-1.7,0-3,1.3-3,3v5h11.1v-6.7l-4.3,4.3l-1.4-1.4L11.6,10z M2,20v9c0,1.7,1.3,3,3,3h8.1V20H2z M35,32c1.7,0,3-1.3,3-3
			v-9H15.1v12H35z M12.7,8l-1-3.8l0,0C11.4,2.9,10.3,2,9,2C7.1,2,5.7,3.8,6.2,5.6l0.1,0.2C6.6,7.1,7.7,8,9,8H12.7z M21.8,5.8
			l0.1-0.2C22.4,3.8,21,2,19.1,2c-1.3,0-2.5,0.9-2.8,2.2l0,0l-1,3.8h3.7C20.4,8,21.5,7.1,21.8,5.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Giftcard2
};
